import axios from 'axios';

const http = axios.create({});

export const httpConfig = (token) => {
  http.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  return http;
}